import React from "react";
import styled from "styled-components";

const Card = styled.div`
  width: 100%;
  max-width: 980px;
  border-radius: 18px;
  box-shadow: rgba(23, 92, 230, 0.12) 0px 4px 24px;
  padding: 22px 24px;
  background: ${({ theme }) => theme.card};
  border: 1px solid rgba(133, 76, 230, 0.5);
  display: flex;
  flex-direction: column;
  gap: 16px;
  transition: all 0.25s ease-in-out;

  &:hover {
    box-shadow: 0px 0px 24px rgba(0, 0, 0, 0.22);
    transform: translateY(-4px);
  }

  @media only screen and (max-width: 768px) {
    padding: 18px;
    gap: 12px;
  }
`;

const Top = styled.div`
  width: 100%;
  display: flex;
  gap: 16px;
  align-items: flex-start;

  @media only screen and (max-width: 640px) {
    gap: 12px;
  }
`;

const Image = styled.img`
  height: 64px;
  width: 64px;
  object-fit: contain;
  background-color: #ffffff;
  border-radius: 14px;
  padding: 8px;
  flex-shrink: 0;

  @media only screen and (max-width: 768px) {
    height: 56px;
    width: 56px;
  }
`;

const Body = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
`;

const Name = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: ${({ theme }) => theme.text_primary};
  margin: 0 0 6px 0;
  line-height: 1.35;

  @media only screen and (max-width: 768px) {
    font-size: 17px;
  }
`;

const Degree = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: ${({ theme }) => theme.text_secondary};
  margin-bottom: 4px;

  @media only screen and (max-width: 768px) {
    font-size: 14px;
  }
`;

const Date = styled.div`
  font-size: 14px;
  font-weight: 400;
  color: ${({ theme }) => `${theme.text_secondary}CC`};

  @media only screen and (max-width: 768px) {
    font-size: 12px;
  }
`;

const Description = styled.p`
  width: 100%;
  font-size: 16px;
  line-height: 1.75;
  color: ${({ theme }) => `${theme.text_primary}DD`};
  margin: 0;

  @media only screen and (max-width: 768px) {
    font-size: 15px;
    line-height: 1.65;
  }
`;

const EducationCard = ({ education }) => {
  return (
    <Card>
      <Top>
        <Image src={education.img} alt={education.school} />
        <Body>
          <Name>{education.school}</Name>
          <Degree>{education.degree}</Degree>
          <Date>{education.date}</Date>
        </Body>
      </Top>

      <Description>{education.desc}</Description>
    </Card>
  );
};

export default EducationCard;
